<template>
  <div
    class="company-card__hint"
    :class="{
      [`company-card__hint--${companyStatus}`]: true,
      toggled: toggled,
    }"
  >
    <component
      :is="hintComponent"
      :company="company"
      @toggle="handleToggle"
      :toggled="toggled"
    ></component>
  </div>
</template>

<script>
import CompanyCardHintActive from '@vue-app/components/company/card/hint/CompanyCardHintActive.vue'
import CompanyCardHintPending from '@vue-app/components/company/card/hint/CompanyCardHintPending.vue'
import CompanyCardHintError from '@vue-app/components/company/card/hint/CompanyCardHintError.vue'
import CompanyCardHintWaitInformation from '@vue-app/components/company/card/hint/CompanyCardHintWaitInformation.vue'

export default {
  name: 'CompanyCardHint',
  props: {
    companyStatus: {
      type: String,
      default: 'pending',
    },
    company: {
      type: Object,
    },
  },
  data() {
    return {
      toggled: false,
    }
  },
  components: {
    CompanyCardHintActive,
    CompanyCardHintPending,
    CompanyCardHintError,
    CompanyCardHintWaitInformation,
  },
  computed: {
    hintComponent: function () {
      switch (this.companyStatus) {
        case 'review':
          return 'CompanyCardHintPending'
        case 'active':
          return 'CompanyCardHintActive'
        case 'hold':
          return 'CompanyCardHintWaitInformation'
        case 'error':
          return 'CompanyCardHintError'
      }
    },
  },
  methods: {
    handleToggle() {
      this.toggled = !this.toggled
    },
  },
}
</script>

<style lang="scss">
@import '@css-app/variables';
@import '@css-app/mixins';
.company-card__hint {
  &-inner {
    display: flex;
    align-items: center;
  }

  &-icon {
    width: 58px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    flex-grow: 0;
    border-radius: 15px;
    margin-right: 15px;

    img,
    svg {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &-text {
    font-weight: 500;
    font-size: pxToRem(12);
    line-height: pxToRem(22);
    color: $h3;
    min-height: 58px;
    flex-grow: 1;
    flex-shrink: 1;
  }
}
@media screen and (max-width: 992px) {
  .company-card {
    &__hint {
      border: 1px solid #64748B;
      border-radius: 15px;
      height: 36px;
      overflow: hidden;

      &.toggled {
        height: auto;
      }

      &.toggled & {
        &-text {
          white-space: initial;
          overflow: visible;
        }
      }

      &-icon {
        margin-top: 2px !important;
      }

      &-arrow {
        margin-left: 20px;
        padding: 4px;
        margin-top: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          opacity: 0.8;
        }
      }

      &-text {
        white-space: nowrap;
        align-items: flex-start;
        min-height: 0;
        display: block !important;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &-inner {
        background-color: transparent !important;
        padding: 7px 10px !important;
        height: 100%;
      }
    }
  }
}
</style>
